import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import { GlobalContextProvider } from './context/global.service';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

